import { track } from '../../analytics/events';
import { isDesktop } from '../../utils/deviceType';

const trackOptions = (orderUuid) => ({
  context: { ip: '0.0.0.0' },
  deviceType: isDesktop() ? 'DESKTOP' : 'MOBILE',
  orderUuid,
  origin: 'MGO',
});

const trackOffersOptIn = (value, orderUuid) => window.analytics.track(
  'ElementClicked',
  {
    webElement: {
      elementType: 'BUTTON',
      text: value === 'YES' ? 'Yes' : 'No',
      name: 'Special Offers Opt In',
      location: 'Instant Savings',
    },
    actionOutcome: 'Submit',
  },
  trackOptions(orderUuid),
);

const trackNext = (orderUuid) => window.analytics.track(
  'ElementClicked',
  {
    webElement: {
      elementType: 'BUTTON',
      text: 'Next',
      location: 'Instant Savings',
    },
    actionOutcome: 'INTERNALLINK',
  },
  trackOptions(orderUuid),
);

export const desktopAnalytics = () => ({
  click: {
    offersOptIn: trackOffersOptIn,
    next: trackNext,
    selectedOffers: (
      accountId,
      adGroupId,
      adId,
      templateId,
    ) => track('selectionCreated', {
      properties: {
        accountId,
        adGroupId,
        adId,
        templateId,
      },
    }),
  },
  view: {
    offerImpressed: (
      accountId,
      adGroupId,
      adId,
      id,
    ) => track('ImpressionCreated', {
      properties: {
        accountId,
        adGroupId,
        adId,
        templateId: id,
      },
    }),
  },
});

export const mobileAnalytics = () => ({
  click: {
    offersOptIn: trackOffersOptIn,
    next: trackNext,
    selectedOffers: (
      accountId,
      adGroupId,
      adId,
      templateId,
    ) => track('selectionCreated', {
      properties: {
        accountId,
        adGroupId,
        adId,
        templateId,
      },
    }),
  },
  view: {
    offerImpressed: (
      accountId,
      adGroupId,
      adId,
      id,
    ) => track('ImpressionCreated', {
      properties: {
        accountId,
        adGroupId,
        adId,
        templateId: id,
      },
    }),
  },
});
